<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import * as animateScroll from 'svelte-scrollto'
	import {
		storeElementID,
		storeData,
		storeSelectedIcon,
		storeShowDrinks,
		storeShowFoods,
		storeShowTools,
	} from '../../library/scripts/Store.svelte'
	import { get_initial_values, get_element_tags, get_blocks, string_to_fontsize } from '../builderUtils'
	import { reorder_layout } from '../../library/scripts/utils'
	import ColorSelector from '../ColorSelector.svelte'
	import SelectValues from '../SelectValues.svelte'
	import SizeSelector from '../SizeSelector.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../library/ShadersAndSpinners/SpinnerCircle.svelte'
	import Alert from '../../modals/Alert.svelte'

	export let width

	const globals = getContext('globals')
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	let iconAlignL = globals.colorDark
	let iconAlignC = globals.colorDark
	let iconAlignR = globals.colorDark
	let iconValignT = globals.colorDark
	let iconValignC = globals.colorDark
	let iconValignB = globals.colorDark
	let iconTitleWeight = globals.colorDark
	let iconTextWeight = globals.colorDark
	let iconTitleStyle = globals.colorDark
	let iconTextStyle = globals.colorDark
	let iconTitleDeco = globals.colorDark
	let iconTextDeco = globals.colorDark
	let iconTitleStroke = globals.colorDark
	let iconTextStroke = globals.colorDark
	let mainTool = globals.mainTool
	let mainToolHover = globals.mainToolHover
	let subTool = globals.subTool
	let subToolHover = globals.subToolHover
	const iconHover = globals.colorError
	const fontSize = globals.fontSize
	const fontFamily = globals.fontFamily
	const smallFonts = globals.fontSizeSmall
	const smallXFonts = globals.fontSizeXSmall

	let shaderChangeOrder = false
	let showTool0
	let showTool1
	let showTool2
	let showTool3
	let showTool4
	let showTool5
	let showTool6
	let showTool7
	let showTool8
	let showTool9
	let showTool10
	let showTool11
	let showTool12
	let showTool13
	let showTool14
	let showTool15
	let showTool16
	let generalTool1
	let generalTool2
	let generalTool3

	//the selectedIcon from store
	let storeIcon

	let elementID
	let config
	let blocks
	let blockID, columnID, elementTag

	//alert window
	let showAlert = false

	let blockBorderColor = 'hsla(0,0%,0%,1)'
	let menuBorderColor = 'hsla(0,0%,0%,1)'

	//css selections
	let blockBackgroundColor,
		blockTitleWidth,
		blockTitleHeight,
		blockTitleAlignHorizontal,
		blockTitleAlignVertical,
		blockTitleFontFamily,
		blockTitleFontColor,
		blockTitleFontSize,
		blockTitleFontWeight,
		blockTitleFontStyle,
		blockTitleFontDeco,
		blockTitleBackgroundColor,
		blockTitleMarginTop,
		blockTitleMarginBottom,
		blockTitlePadding,
		blockTitleShadowColor,
		blockTitleShadowOffsetX,
		blockTitleShadowOffsetY,
		blockTitleShadowBlur,
		blockBoxShadowX,
		blockBoxShadowY,
		blockBoxShadowBlur,
		blockBoxShadowColor,
		menuWidth,
		menuHeight,
		menuBGC,
		menuBGS,
		menuBGR,
		menuBGB,
		menuBGP,
		borderTopRadius,
		borderBottomRadius,
		borderLeftWidth,
		borderLeftStyle,
		borderLeftColor,
		borderTopWidth,
		borderTopStyle,
		borderTopColor,
		borderRightWidth,
		borderRightStyle,
		borderRightColor,
		borderBottomWidth,
		borderBottomStyle,
		borderBottomColor,
		blockMarginTop,
		blockMarginBottom,
		blockPadding,
		categoryBgColor,
		categoryOpac,
		categoryPadding,
		categoryFontSize,
		categoryFontWeight,
		categoryFontStyle,
		categoryFontColor,
		categoryFontOpac,
		categoryFontDeco,
		categoryFontFamily,
		categoryMargin,
		itemFontFamily,
		itemFontSize,
		itemFontColor,
		itemFontOpac,
		itemFontStyle,
		titleOpac,
		blockOpac,
		bbLOpac,
		btShadowOpac,
		menuContainerBG,
		menuBGOpac,
		menuContainerMT,
		menuContainerMB,
		menuConatainerP,
		menuBG,
		menuOpac,
		menuMT,
		menuMB,
		menuP,
		menuSC,
		menuSopac,
		menuSX,
		menuSY,
		menuSB,
		menuBLopac,
		menuBRT,
		menuBRB,
		menuBLW,
		menuBLS,
		menuBLC,
		menuBTW,
		menuBTS,
		menuBTC,
		menuBRW,
		menuBRS,
		menuBRC,
		menuBBW,
		menuBBS,
		menuBBC,
		itemTFC,
		itemTFOpac

	//the selectedIcon from store
	let selectedIcon

	//the values to send to sizeSelectors
	let borderWidth
	let menuBW

	//set icons
	let icon1 = false
	let icon2 = false
	let icon3 = false
	let icon4 = false
	let icon5 = false
	let icon6 = false
	let icon7 = false
	let icon8 = false
	let icon9 = false
	let icon10 = false

	let icon1Color = iconColor
	let icon2Color = iconColor
	let icon3Color = iconColor
	let icon4Color = iconColor
	let icon5Color = iconColor

	let icon6Color = iconColor
	let icon7Color = iconColor
	let icon8Color = iconColor
	let icon9Color = iconColor
	let icon10Color = iconColor

	//stative ID for getElementById in SelectValues
	const idSelect1 = 'selFont'
	const idSelect2 = 'selSize'
	const idColor1 = '101'
	const idColor2 = '102'
	const idColor3 = '103'
	const idColor4 = '104'
	const idColor5 = '105'
	const idColor6 = '106'
	const idColor7 = '107'
	const idColor8 = '108'
	const idColor9 = '109'
	const idColor10 = '110'
	const idColor11 = '111'
	const idColor12 = '112'
	const idColor13 = '113'
	const idColor14 = '114'
	const idColor15 = '115'
	const idBlockMarginTop = '3'
	const idBlockMarginBottom = '4'
	const idBlockPadding = '5'
	const idTitleHeight = '6'
	const idTitleMarginTop = '7'
	const idTitleMarginBottom = '8'
	const idTitlePadding = '9'
	const idBlockBorderWidth = '10'
	const idBlockBTRadius = '11'
	const idBlockBBRadius = '12'
	const idBlockShadowY = '13'
	const idBlockShadowBlur = '14'
	const idBlockTitleShadowX = '15'
	const idBlockTitleShadowY = '16'
	const idBlockTitleShadowB = '17'
	const idMenuContainerMT = '18'
	const idMenuContainerMB = '19'
	const idmenuConatainerP = '20'
	const idMenuWidth = '21'
	const idMenuMT = '22'
	const idMenuMB = '23'
	const idMenuSX = '24'
	const idMenuSY = '25'
	const idMenuSB = '26'
	const idMenuP = '27'
	const idMenuBW = '28'
	const idMenuBRT = '29'
	const idMenuBB = '30'
	const idCat = '31'
	const idCatPad = '32'
	const idCatMarg = '33'

	//show border tools
	let iconSelected = false

	//hide all tools if window is closed
	let showTools = false
	const stoShowTools = storeShowTools.subscribe((value) => {
		showTools = value
	})

	$: if (!showTools) {
		generalTool1 = false
		generalTool2 = false
		generalTool3 = false

		showTool0 = false
		showTool1 = false
		showTool2 = false
		showTool3 = false
		showTool4 = false
		showTool5 = false
		showTool6 = false
		showTool7 = false
		showTool8 = false
		showTool9 = false
		showTool10 = false
		showTool11 = false
		showTool12 = false
		showTool13 = false
		showTool14 = false
		showTool15 = false
		showTool16 = false
	}

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
		showTool0 = false
		showTool1 = false
		showTool2 = false
		showTool3 = false
		showTool4 = false
		showTool5 = false
		showTool6 = false
		showTool7 = false
		showTool8 = false
		showTool9 = false
		showTool10 = false
		showTool11 = false
		showTool12 = false
		showTool13 = false
		showTool14 = false
		showTool15 = false
		showTool16 = false
	})

	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		storeIcon = value
	})

	//set the initial css values from config.json

	$: if (elementID === 'drinks' || elementID === 'foods') {
		if (elementID === 'drinks') storeShowFoods.set(false)
		if (elementID === 'foods') storeShowDrinks.set(false)

		const tags = get_element_tags(elementID)
		blockID = tags[0]
		columnID = tags[1]
		elementTag = tags[2]
		const values = get_initial_values(elementID, blocks, tags)
		blockBackgroundColor = values[0]
		blockTitleWidth = values[1]
		blockTitleHeight = values[2]
		blockTitleAlignHorizontal = values[3]
		blockTitleAlignVertical = values[4]
		blockTitleFontFamily = values[5]
		blockTitleFontColor = values[6]
		blockTitleFontSize = values[7]
		blockTitleFontWeight = values[8]
		blockTitleFontStyle = values[9]
		blockTitleFontDeco = values[10]
		set_fontstyle_initial_value('title', blockTitleFontWeight, blockTitleFontStyle, blockTitleFontDeco)
		blockTitleBackgroundColor = values[11]
		blockTitleMarginTop = values[12]
		blockTitleMarginBottom = values[13]
		blockTitlePadding = values[14]
		blockTitleShadowColor = values[15]
		blockTitleShadowOffsetX = values[16]
		blockTitleShadowOffsetY = values[17]
		blockTitleShadowBlur = values[18]
		blockBoxShadowX = values[19]
		blockBoxShadowY = values[20]
		blockBoxShadowBlur = values[21]
		blockBoxShadowColor = values[22]
		menuWidth = values[23]
		menuHeight = values[24]
		menuBGC = values[25]
		menuBGS = values[26]
		menuBGR = values[27]
		menuBGB = values[28]
		menuBGP = values[29]
		borderTopRadius = values[30]
		borderBottomRadius = values[31]
		borderLeftWidth = values[32]
		borderLeftStyle = values[33]
		borderLeftColor = values[34]
		borderTopWidth = values[35]
		borderTopStyle = values[36]
		borderTopColor = values[37]
		borderRightWidth = values[38]
		borderRightStyle = values[39]
		borderRightColor = values[40]
		borderBottomWidth = values[41]
		borderBottomStyle = values[42]
		borderBottomColor = values[43]
		blockMarginTop = values[44]
		blockMarginBottom = values[45]
		blockPadding = values[46]
		categoryBgColor = values[47]
		categoryOpac = values[48]
		categoryPadding = values[49]
		categoryFontSize = values[50]
		categoryFontWeight = values[51]
		categoryFontStyle = values[52]
		categoryFontColor = values[53]
		categoryFontOpac = values[54]
		categoryFontDeco = values[55]
		categoryFontFamily = values[56]
		set_fontstyle_initial_value('text', categoryFontWeight, categoryFontStyle, categoryFontDeco)
		categoryMargin = values[57]
		itemFontFamily = values[58]
		itemFontSize = values[59]
		itemFontColor = values[60]
		itemFontOpac = values[61]
		itemFontStyle = values[62]
		titleOpac = values[63]
		blockOpac = values[64]
		btShadowOpac = values[65]
		menuContainerBG = values[66]
		menuBGOpac = values[67]
		menuContainerMT = values[68]
		menuContainerMB = values[69]
		menuConatainerP = values[70]
		menuBG = values[71]
		menuOpac = values[72]
		menuMT = values[73]
		menuMB = values[74]
		menuP = values[75]
		menuSC = values[76]
		menuSopac = values[77]
		menuSX = values[78]
		menuSY = values[79]
		menuSB = values[80]
		menuBRT = values[81]
		menuBRB = values[82]
		menuBLW = values[83]
		menuBLS = values[84]
		menuBLC = values[85]
		menuBTW = values[86]
		menuBTS = values[87]
		menuBTC = values[88]
		menuBRW = values[89]
		menuBRS = values[90]
		menuBRC = values[91]
		menuBBW = values[92]
		menuBBS = values[93]
		menuBBC = values[94]
		itemTFC = values[95]
		itemTFOpac = values[96]
		set_icon_BTA(blockTitleAlignHorizontal)
		set_icon_BTVA(blockTitleAlignVertical)
		set_icon_color('Menu', 'none')

		if (borderLeftWidth > 0) {
			icon1 = true
			set_icon_color('Block', 'left')
		}
		if (borderTopWidth > 0) {
			icon2 = true
			set_icon_color('Block', 'top')
		}

		if (borderRightWidth > 0) {
			icon3 = true
			set_icon_color('Block', 'right')
		}

		if (borderBottomWidth > 0) {
			icon4 = true
			set_icon_color('Block', 'bottom')
		}

		if (borderLeftWidth > 0 && borderTopWidth > 0 && borderRightWidth > 0 && borderBottomWidth > 0) {
			icon1 = true
			icon2 = true
			icon3 = true
			icon4 = true
			icon5 = true
			set_icon_color('Block', 'all')
		}

		if (menuBLW > 0) {
			icon6 = true
			set_icon_color('Menu', 'left')
		}
		if (menuBTW > 0) {
			icon7 = true
			set_icon_color('Menu', 'top')
		}

		if (menuBRW > 0) {
			icon8 = true
			set_icon_color('Menu', 'right')
		}

		if (menuBBW > 0) {
			icon9 = true
			set_icon_color('Menu', 'bottom')
		}

		if (menuBLW > 0 && menuBTW > 0 && menuBRW > 0 && menuBBW > 0) {
			icon6 = true
			icon7 = true
			icon8 = true
			icon9 = true
			icon10 = true
			set_icon_color('Menu', 'all')
		}
	}

	$: if (!icon1 && !icon2 && !icon3 && !icon4 && !icon5) iconSelected = false
	$: if (!icon6 && !icon7 && !icon8 && !icon9 && !icon10) iconSelected = false

	$: if (storeIcon === 'icon1') borderWidth = borderLeftWidth
	$: if (storeIcon === 'icon2') borderWidth = borderTopWidth
	$: if (storeIcon === 'icon3') borderWidth = borderRightWidth
	$: if (storeIcon === 'icon4') borderWidth = borderBottomWidth
	$: if (storeIcon === 'icon5') borderWidth = borderLeftWidth

	$: if (storeIcon === 'icon6') menuBW = menuBLW
	$: if (storeIcon === 'icon7') menuBW = menuBTW
	$: if (storeIcon === 'icon8') menuBW = menuBRW
	$: if (storeIcon === 'icon9') menuBW = menuBBW
	$: if (storeIcon === 'icon10') menuBW = menuBLW

	const set_icon_color = (cmd, c) => {
		if (cmd === 'Block') {
			if (c === 'left') icon1Color = iconHover
			if (c === 'top') icon2Color = iconHover
			if (c === 'right') icon3Color = iconHover
			if (c === 'bottom') icon4Color = iconHover
			if (c === 'all') {
				icon1Color = iconHover
				icon2Color = iconHover
				icon3Color = iconHover
				icon4Color = iconHover
				icon5Color = iconHover
			}
			if (c === 'none') {
				icon1Color = iconColor
				icon2Color = iconColor
				icon3Color = iconColor
				icon4Color = iconColor
				icon5Color = iconColor
			}
		}

		if (cmd === 'Menu') {
			if (c === 'left') icon6Color = iconHover
			if (c === 'top') icon7Color = iconHover
			if (c === 'right') icon8Color = iconHover
			if (c === 'bottom') icon9Color = iconHover
			if (c === 'all') {
				icon6Color = iconHover
				icon7Color = iconHover
				icon8Color = iconHover
				icon9Color = iconHover
				icon10Color = iconHover
			}
			if (c === 'none') {
				icon6Color = iconColor
				icon7Color = iconColor
				icon8Color = iconColor
				icon9Color = iconColor
				icon10Color = iconColor
			}
		}
	}

	const close_alert = () => {
		showAlert = false
	}

	const change_order = async (block, direction) => {
		let menuContainer
		if (block === 'drinks') menuContainer = document.getElementById('drinks_menu')
		if (block === 'foods') menuContainer = document.getElementById('foods_menu')

		if (menuContainer) {
			showAlert = true
			return
		}

		let changeOrder = true
		let blocks = get_blocks(config)
		blocks.forEach((bl, index) => {
			if (bl.blockName === block) {
				if (config.blocks[index].layoutOrder === 0 && direction === 'up') {
					changeOrder = false
				}
				if (config.blocks[index].layoutOrder === blocks.length - 1 && direction === 'down') {
					changeOrder = false
				}
			}
		})

		if (changeOrder) {
			shaderChangeOrder = true
			const reorder = await reorder_layout(block, direction)
			storeData.set(reorder)
			shaderChangeOrder = false
		}
	}

	const set_fontstyle_initial_value = (c, w, s, d) => {
		if (c === 'title') {
			if (w === 'bold') iconTitleWeight = iconHover
			if (w === 'normal') iconTitleWeight = iconColor
			if (s === 'italic') iconTitleStyle = iconHover
			if (s === 'normal') iconTitleStyle = iconColor
			if (d === 'none') {
				iconTitleDeco = iconColor
				iconTitleStroke = iconColor
			}
			if (d === 'underline') {
				iconTitleDeco = iconHover
				iconTitleStroke = iconColor
			}
			if (d === 'line-through') {
				iconTitleDeco = iconColor
				iconTitleStroke = iconHover
			}
		}

		if (c === 'text') {
			if (w === 'bold') iconTextWeight = iconHover
			if (w === 'normal') iconTextWeight = iconColor
			if (s === 'italic') iconTextStyle = iconHover
			if (s === 'normal') iconTextStyle = iconColor
			if (d === 'none') {
				iconTextDeco = iconColor
				iconTextStroke = iconColor
			}
			if (d === 'underline') {
				iconTextDeco = iconHover
				iconTextStroke = iconColor
			}
			if (d === 'line-through') {
				iconTextDeco = iconColor
				iconTextStroke = iconHover
			}
		}
	}

	const set_icon_BTA = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconAlignL = iconHover
				iconAlignC = iconColor
				iconAlignR = iconColor
				return
			}
			if (v === 'center') {
				iconAlignL = iconColor
				iconAlignC = iconHover
				iconAlignR = iconColor
				return
			}

			if (v === 'flex-end') {
				iconAlignL = iconColor
				iconAlignC = iconColor
				iconAlignR = iconHover
				return
			}
		}
	}

	const set_icon_BTVA = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconValignT = iconHover
				iconValignC = iconColor
				iconValignB = iconColor
				return
			}
			if (v === 'center') {
				iconValignT = iconColor
				iconValignC = iconHover
				iconValignB = iconColor
				return
			}

			if (v === 'flex-end') {
				iconValignT = iconColor
				iconValignC = iconColor
				iconValignB = iconHover
				return
			}
		}
	}

	const set_css_tag = (cssTag, cmd) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (cmd === 'BBGC') block.blockBackgroundColor = cssTag
				if (cmd === 'BMT') block.blockMarginTop = cssTag
				if (cmd === 'BMB') block.blockMarginBottom = cssTag
				if (cmd === 'BP') block.blockPadding = cssTag
				if (cmd === 'BBT') block.borderTop = cssTag
				if (cmd === 'BBTR') block.borderTopRadius = cssTag
				if (cmd === 'BBBR') block.borderBottomRadius = cssTag
				if (cmd === 'BSC') block.blockBoxShadowColor = cssTag
				if (cmd === 'BSY') block.blockBoxShadowY = cssTag
				if (cmd === 'BSB') block.blockBoxShadowBlur = cssTag
				if (cmd === 'BTBG') block.blockTitleBackgroundColor = cssTag
				if (cmd === 'BTMT') block.blockTitleMarginTop = cssTag
				if (cmd === 'BTMB') block.blockTitleMarginBottom = cssTag
				if (cmd === 'BTP') block.blockTitlePadding = cssTag
				if (cmd === 'BTFF') block.blockTitleFontFamily = cssTag
				if (cmd === 'BTFC') block.blockTitleFontColor = cssTag
				if (cmd === 'BTFS') block.blockTitleFontSize = cssTag
				if (cmd === 'BTFW') block.blockTitleFontWeight = cssTag
				if (cmd === 'BTFST') block.blockTitleFontStyle = cssTag
				if (cmd === 'BTFD') block.blockTitleFontDeco = cssTag
				if (cmd === 'BTFSC') block.blockTitleShadowColor = cssTag
				if (cmd === 'BTFSX') block.blockTitleShadowOffsetX = cssTag
				if (cmd === 'BTFSY') block.blockTitleShadowOffsetY = cssTag
				if (cmd === 'BTFBL') block.blockTitleShadowBlur = cssTag
				if (cmd === 'BTA') block.blockTitleAlignHorizontal = cssTag
				if (cmd === 'BTVA') block.blockTitleAlignVertical = cssTag
				if (cmd === 'BTH') block.blockTitleHeight = cssTag

				if (cmd === 'BBC') {
					if (icon1 && selectedIcon === 'icon1') block.borderLeftColor = cssTag
					if (icon2 && selectedIcon === 'icon2') block.borderTopColor = cssTag
					if (icon3 && selectedIcon === 'icon3') block.borderRightColor = cssTag
					if (icon4 && selectedIcon === 'icon4') block.borderBottomColor = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftColor = cssTag
						block.borderTopColor = cssTag
						block.borderRightColor = cssTag
						block.borderBottomColor = cssTag
					}
				}

				if (cmd === 'BBL') {
					if (icon1 && selectedIcon === 'icon1') {
						block.borderLeftColor = cssTag
						block.borderLeftWidth = 1
						icon1Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderLeftWidth = 0
						icon1Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'BBT') {
					if (icon2 && selectedIcon === 'icon2') {
						block.borderTopColor = cssTag
						block.borderTopWidth = 1
						icon2Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderTopWidth = 0
						icon2Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'BBR') {
					if (icon3 && selectedIcon === 'icon3') {
						block.borderRightColor = cssTag
						block.borderRightWidth = 1
						icon3Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderRightWidth = 0
						icon3Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'BBB') {
					if (icon4 && selectedIcon === 'icon4') {
						block.borderBottomColor = cssTag
						block.borderBottomWidth = 1
						icon4Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderBottomWidth = 0
						icon4Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'BBA') {
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftColor = cssTag
						block.borderLeftWidth = 1
						block.borderTopColor = cssTag
						block.borderTopWidth = 1
						block.borderRightColor = cssTag
						block.borderRightWidth = 1
						block.borderBottomColor = cssTag
						block.borderBottomWidth = 1
						icon5Color = iconHover
						icon1Color = iconHover
						icon2Color = iconHover
						icon3Color = iconHover
						icon4Color = iconHover
					} else {
						block.borderLeftWidth = 0
						block.borderTopWidth = 0
						block.borderRightWidth = 0
						block.borderBottomWidth = 0
						icon5Color = iconColor
						icon1Color = iconColor
						icon2Color = iconColor
						icon3Color = iconColor
						icon4Color = iconColor
						icon1 = false
						icon2 = false
						icon3 = false
						icon4 = false
						icon5 = false
					}
				}

				if (cmd === 'BBW') {
					if (icon1 && selectedIcon === 'icon1') block.borderLeftWidth = cssTag
					if (icon2 && selectedIcon === 'icon2') block.borderTopWidth = cssTag
					if (icon3 && selectedIcon === 'icon3') block.borderRightWidth = cssTag
					if (icon4 && selectedIcon === 'icon4') block.borderBottomWidth = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftWidth = cssTag
						block.borderTopWidth = cssTag
						block.borderRightWidth = cssTag
						block.borderBottomWidth = cssTag
					}
				}

				if (cmd === 'MCBGC') block.menuContainerBG = cssTag
				if (cmd === 'MCMT') block.menuContainerMT = cssTag
				if (cmd === 'MCMB') block.menuContainerMB = cssTag
				if (cmd === 'MCP') block.menuConatainerP = cssTag
				if (cmd === 'MC') block.menuBG = cssTag
				if (cmd === 'MW') block.menuWidth = cssTag
				if (cmd === 'MMT') block.menuMT = cssTag
				if (cmd === 'MMB') block.menuMB = cssTag
				if (cmd === 'MP') block.menuP = cssTag
				if (cmd === 'MSC') block.menuSC = cssTag
				if (cmd === 'MSX') block.menuSX = cssTag
				if (cmd === 'MSY') block.menuSY = cssTag
				if (cmd === 'MSB') block.menuSB = cssTag

				if (cmd === 'MBC') {
					if (icon6 && selectedIcon === 'icon6') block.menuBLC = cssTag
					if (icon7 && selectedIcon === 'icon7') block.menuBTC = cssTag
					if (icon8 && selectedIcon === 'icon8') block.menuBRC = cssTag
					if (icon9 && selectedIcon === 'icon9') block.menuBBC = cssTag
					if (icon10 && selectedIcon === 'icon10') {
						block.menuBLC = cssTag
						block.menuBTC = cssTag
						block.menuBRC = cssTag
						block.menuBBC = cssTag
					}
				}

				if (cmd === 'MBLC') {
					if (icon6 && selectedIcon === 'icon6') {
						block.menuBLC = cssTag
						block.menuBLW = 1
						icon6Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.menuBLW = 0
						icon6Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'MBTC') {
					if (icon7 && selectedIcon === 'icon7') {
						block.menuBTC = cssTag
						block.menuBTW = 1
						icon7Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.menuBTW = 0
						icon7Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'MBRC') {
					if (icon8 && selectedIcon === 'icon8') {
						block.menuBRC = cssTag
						block.menuBRW = 1
						icon8Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.menuBRW = 0
						icon8Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'MBBC') {
					if (icon9 && selectedIcon === 'icon9') {
						block.menuBBC = cssTag
						block.menuBBW = 1
						icon9Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.menuBBW = 0
						icon9Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'MBAC') {
					if (icon10 && selectedIcon === 'icon10') {
						block.menuBLC = cssTag
						block.menuBLW = 1
						block.menuBTC = cssTag
						block.menuBTW = 1
						block.menuBRC = cssTag
						block.menuBRW = 1
						block.menuBBC = cssTag
						block.menuBBW = 1
						icon10Color = iconHover
						icon6Color = iconHover
						icon7Color = iconHover
						icon8Color = iconHover
						icon9Color = iconHover
					} else {
						block.menuBLW = 0
						block.menuBTW = 0
						block.menuBRW = 0
						block.menuBBW = 0
						icon10Color = iconColor
						icon6Color = iconColor
						icon7Color = iconColor
						icon8Color = iconColor
						icon9Color = iconColor
						icon6 = false
						icon7 = false
						icon8 = false
						icon9 = false
						icon10 = false
					}
				}

				if (cmd === 'MBW') {
					if (icon6 && selectedIcon === 'icon6') block.menuBLW = cssTag
					if (icon7 && selectedIcon === 'icon7') block.menuBTW = cssTag
					if (icon8 && selectedIcon === 'icon8') block.menuBRW = cssTag
					if (icon9 && selectedIcon === 'icon9') block.menuBBW = cssTag
					if (icon10 && selectedIcon === 'icon10') {
						block.menuBLW = cssTag
						block.menuBTW = cssTag
						block.menuBRW = cssTag
						block.menuBBW = cssTag
					}
				}

				if (cmd === 'MBT') block.menuBRT = cssTag
				if (cmd === 'MBB') block.menuBRB = cssTag
				if (cmd === 'CBGC') block.categoryBgColor = cssTag
				if (cmd === 'SIM') block.categoryMargin = cssTag
				if (cmd === 'CBL') block.menuBGB = cssTag
				if (cmd === 'CBP') block.categoryPadding = cssTag
				if (cmd === 'CTFC') block.categoryFontColor = cssTag
				if (cmd === 'CTFF') block.categoryFontFamily = cssTag
				if (cmd === 'CTFS') block.categoryFontSize = cssTag
				if (cmd === 'CTFW') block.categoryFontWeight = cssTag
				if (cmd === 'CTFST') block.categoryFontStyle = cssTag
				if (cmd === 'CTFD') block.categoryFontDeco = cssTag
				if (cmd === 'CIFC') block.itemFontColor = cssTag
				if (cmd === 'CITFC') block.itemTitleFontColor = cssTag
				if (cmd === 'CIFF') block.itemFontFamily = cssTag
				if (cmd === 'CIFS') block.itemFontSize = cssTag
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const set_bg_color = (e) => {
		set_css_tag(e.detail.color, 'BBGC')
	}

	const set_block_margin_top = (e) => {
		set_css_tag(e.detail.value, 'BMT')
	}

	const set_block_margin_bottom = (e) => {
		set_css_tag(e.detail.value, 'BMB')
	}

	const set_block_padding = (e) => {
		set_css_tag(e.detail.value, 'BP')
	}

	const set_block_border_color = (e) => {
		set_css_tag(e.detail.color, 'BBC')
	}

	const set_block_border_width = (e) => {
		set_css_tag(e.detail.value, 'BBW')
	}

	const set_block_BRT = (e) => {
		set_css_tag(e.detail.value, 'BBTR')
	}

	const set_block_BRB = (e) => {
		set_css_tag(e.detail.value, 'BBBR')
	}

	const set_block_SC = (e) => {
		set_css_tag(e.detail.color, 'BSC')
	}

	const set_block_SY = (e) => {
		set_css_tag(e.detail.value, 'BSY')
	}

	const set_block_SB = (e) => {
		set_css_tag(e.detail.value, 'BSB')
	}

	const set_block_title_height = (e) => {
		set_css_tag(e.detail.value, 'BTH')
	}

	const set_block_title_FC = (e) => {
		set_css_tag(e.detail.color, 'BTFC')
	}

	const set_title_bg_color = (e) => {
		set_css_tag(e.detail.color, 'BTBG')
	}

	const set_block_Title_FF = (e) => {
		set_css_tag(e.detail.font, 'BTFF')
	}

	const set_block_Title_FS = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'BTFS')
	}

	const set_block_Title_FW = () => {
		let titleWeight
		if (elementID === 'drinks') titleWeight = document.querySelector('#drinkstitle').style.fontWeight
		if (elementID === 'foods') titleWeight = document.querySelector('#foodstitle').style.fontWeight

		if (titleWeight === '' || titleWeight === 'normal') {
			iconTitleWeight = iconHover
			set_css_tag('bold', 'BTFW')
		} else {
			iconTitleWeight = iconColor
			set_css_tag('normal', 'BTFW')
		}
	}

	const set_block_Title_FSTYLE = () => {
		let titleStyle
		if (elementID === 'drinks') titleStyle = document.querySelector('#drinkstitle').style.fontStyle
		if (elementID === 'foods') titleStyle = document.querySelector('#foodstitle').style.fontStyle

		if (titleStyle === '' || titleStyle === 'normal') {
			iconTitleStyle = iconHover
			set_css_tag('italic', 'BTFST')
		} else {
			iconTitleStyle = iconColor
			set_css_tag('normal', 'BTFST')
		}
	}

	const set_block_Title_underline = () => {
		let titleUnderline
		if (elementID === 'drinks') titleUnderline = document.querySelector('#drinkstitle').style.textDecoration
		if (elementID === 'foods') titleUnderline = document.querySelector('#foodstitle').style.textDecoration

		if (titleUnderline === '' || titleUnderline === 'none' || titleUnderline === 'line-through') {
			iconTitleDeco = iconHover
			set_css_tag('underline', 'BTFD')
		} else {
			iconTitleDeco = iconColor
			set_css_tag('none', 'BTFD')
		}
	}

	const block_Title_strikethrough = () => {
		let titleLinethrough
		if (elementID === 'drinks') titleLinethrough = document.querySelector('#drinkstitle').style.textDecoration
		if (elementID === 'foods') titleLinethrough = document.querySelector('#foodstitle').style.textDecoration

		if (titleLinethrough === '' || titleLinethrough === 'none' || titleLinethrough === 'underline') {
			iconTitleStroke = iconHover
			iconTitleStyle = iconColor
			set_css_tag('line-through', 'BTFD')
		} else {
			iconTitleStroke = iconColor
			set_css_tag('none', 'BTFD')
		}
	}

	const set_block_title_AL = () => {
		set_css_tag('flex-start', 'BTA')
	}

	const set_block_title_AC = () => {
		set_css_tag('center', 'BTA')
	}

	const set_block_title_AR = () => {
		set_css_tag('flex-end', 'BTA')
	}

	const set_block_title_VAT = () => {
		set_css_tag('flex-start', 'BTVA')
	}

	const set_block_title_VAC = () => {
		set_css_tag('center', 'BTVA')
	}

	const set_block_title_VAB = () => {
		set_css_tag('flex-end', 'BTVA')
	}

	const set_block_title_SC = (e) => {
		set_css_tag(e.detail.color, 'BTFSC')
	}

	const set_block_title_MT = (e) => {
		set_css_tag(e.detail.value, 'BTMT')
	}

	const set_block_title_MB = (e) => {
		set_css_tag(e.detail.value, 'BTMB')
	}

	const set_block_title_P = (e) => {
		set_css_tag(e.detail.value, 'BTP')
	}

	const set_block_title_SX = (e) => {
		set_css_tag(e.detail.value, 'BTFSX')
	}

	const set_block_title_SY = (e) => {
		set_css_tag(e.detail.value, 'BTFSY')
	}

	const set_block_title_SB = (e) => {
		set_css_tag(e.detail.value, 'BTFBL')
	}

	const set_menu_MCBGC = (e) => {
		set_css_tag(e.detail.color, 'MCBGC')
	}

	const set_menu_MCMT = (e) => {
		set_css_tag(e.detail.value, 'MCMT')
	}

	const set_menu_MCMB = (e) => {
		set_css_tag(e.detail.value, 'MCMB')
	}

	const set_menu_MCP = (e) => {
		set_css_tag(e.detail.value, 'MCP')
	}

	const set_menu_MBG = (e) => {
		set_css_tag(e.detail.color, 'MC')
	}

	const set_menu_MW = (e) => {
		set_css_tag(e.detail.value, 'MW')
	}

	const set_menu_MMT = (e) => {
		set_css_tag(e.detail.value, 'MMT')
	}

	const set_menu_MMB = (e) => {
		set_css_tag(e.detail.value, 'MMB')
	}

	const set_menu_MP = (e) => {
		set_css_tag(e.detail.value, 'MP')
	}

	const set_menu_MSC = (e) => {
		set_css_tag(e.detail.color, 'MSC')
	}

	const set_menu_MSX = (e) => {
		set_css_tag(e.detail.value, 'MSX')
	}

	const set_menu_MSY = (e) => {
		set_css_tag(e.detail.value, 'MSY')
	}

	const set_menu_MSB = (e) => {
		set_css_tag(e.detail.value, 'MSB')
	}

	const set_menu_BC = (e) => {
		set_css_tag(e.detail.color, 'MBC')
	}

	const set_menu_BW = (e) => {
		set_css_tag(e.detail.value, 'MBW')
	}

	const set_menu_BRT = (e) => {
		set_css_tag(e.detail.value, 'MBT')
	}

	const set_menu_BRB = (e) => {
		set_css_tag(e.detail.value, 'MBB')
	}

	const set_category_BG = (e) => {
		set_css_tag(e.detail.color, 'CBGC')
	}

	const set_inset_margin = (e) => {
		set_css_tag(e.detail.value, 'SIM')
	}

	const set_category_B = (e) => {
		set_css_tag(e.detail.value, 'CBL')
	}

	const set_category_P = (e) => {
		set_css_tag(e.detail.value, 'CBP')
	}

	const set_item_title_FC = (e) => {
		set_css_tag(e.detail.color, 'CITFC')
	}
	const set_category_FC = (e) => {
		set_css_tag(e.detail.color, 'CTFC')
	}

	const set_category_FF = (e) => {
		set_css_tag(e.detail.font, 'CTFF')
	}

	const set_category_FS = (e) => {
		set_css_tag(string_to_fontsize(e.detail.size), 'CTFS')
	}

	const set_category_title_FW = () => {
		let titleFW
		if (elementID === 'drinks') titleFW = document.querySelector('#drinkscategory').style.fontWeight
		if (elementID === 'foods') titleFW = document.querySelector('#foodscategory').style.fontWeight
		if (titleFW === '' || titleFW === 'normal') {
			iconTextWeight = iconHover
			set_css_tag('bold', 'CTFW')
		} else {
			iconTextWeight = iconColor
			set_css_tag('normal', 'CTFW')
		}
	}

	const set_category_title_FSTYLE = () => {
		let titleStyle
		if (elementID === 'drinks') titleStyle = document.querySelector('#drinkscategory').style.fontStyle
		if (elementID === 'foods') titleStyle = document.querySelector('#foodscategory').style.fontStyle

		if (titleStyle === '' || titleStyle === 'normal') {
			iconTextWeight = iconHover
			set_css_tag('italic', 'CTFST')
		} else {
			iconTextWeight = iconColor
			set_css_tag('normal', 'CTFST')
		}
	}

	const set_category_title_underline = () => {
		let titleDeco
		if (elementID === 'drinks') titleDeco = document.querySelector('#drinkscategory').style.textDecoration
		if (elementID === 'foods') titleDeco = document.querySelector('#foodscategory').style.textDecoration

		if (titleDeco === '' || titleDeco === 'none' || titleDeco === 'line-through') {
			iconTextDeco = iconHover
			set_css_tag('underline', 'CTFD')
		} else {
			iconTextDeco = iconColor
			set_css_tag('none', 'CTFD')
		}
	}

	const set_text_strikethrough = () => {
		let titleDeco
		if (elementID === 'drinks') titleDeco = document.querySelector('#drinkscategory').style.textDecoration
		if (elementID === 'foods') titleDeco = document.querySelector('#foodscategory').style.textDecoration
		if (titleDeco === '' || titleDeco === 'none' || titleDeco === 'underline') {
			iconTextStroke = iconHover
			iconTextStyle = iconColor
			set_css_tag('line-through', 'CTFD')
		} else {
			iconTextStroke = iconColor
			set_css_tag('none', 'CTFD')
		}
	}

	const set_item_FC = (e) => {
		set_css_tag(e.detail.color, 'CIFC')
	}

	const set_item_FF = (e) => {
		set_css_tag(e.detail.font, 'CIFF')
	}

	const set_item_FS = (e) => {
		set_css_tag(string_to_fontsize(e.detail.size), 'CIFS')
	}

	const open_tool = (t) => {
		switch (t) {
			case 'generalTool1':
				generalTool1 = generalTool1 === true ? false : true
				showTool2 = false
				showTool3 = false
				break

			case 'generalTool2':
				generalTool2 = generalTool2 === true ? false : true
				showTool5 = false
				showTool6 = false
				showTool7 = false
				break

			case 'generalTool3':
				generalTool3 = generalTool3 === true ? false : true
				showTool9 = false
				showTool10 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				break

			case 0:
				showTool0 = showTool0 === true ? false : true
				showTool1 = false
				showTool4 = false
				showTool8 = false
				break
			case 1:
				showTool1 = showTool1 === true ? false : true
				showTool0 = false
				showTool4 = false
				showTool8 = false
				break

			case 2:
				showTool2 = showTool2 === true ? false : true
				generalTool1 = false
				showTool3 = false
				break

			case 3:
				showTool3 = showTool3 === true ? false : true
				generalTool1 = false
				showTool2 = false
				break

			case 4:
				showTool4 = showTool4 === true ? false : true
				showTool1 = false
				showTool0 = false
				showTool8 = false
				break

			case 5:
				showTool5 = showTool5 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool7 = false
				break
			case 6:
				showTool6 = showTool6 === true ? false : true
				generalTool2 = false
				showTool5 = false
				showTool7 = false
				break

			case 7:
				showTool7 = showTool7 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool5 = false
				break

			case 8:
				showTool8 = showTool8 === true ? false : true
				showTool1 = false
				showTool4 = false
				showTool0 = false
				if (elementID === 'drinks') {
					storeShowDrinks.set(showTool8)
					animateScroll.scrollTo({ element: '#drinkstitle' })
				}
				if (elementID === 'foods') storeShowFoods.set(showTool8)
				break

			case 9:
				showTool9 = showTool9 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				break

			case 10:
				showTool10 = showTool10 === true ? false : true
				generalTool3 = false
				showTool9 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				break

			case 11:
				showTool11 = showTool11 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool9 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				break

			case 12:
				showTool12 = showTool12 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool11 = false
				showTool9 = false
				showTool13 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				break

			case 13:
				showTool13 = showTool13 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool11 = false
				showTool12 = false
				showTool9 = false
				showTool14 = false
				showTool15 = false
				showTool16 = false
				break

			case 14:
				showTool14 = showTool14 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				showTool9 = false
				showTool15 = false
				showTool16 = false
				break

			case 15:
				showTool15 = showTool15 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				showTool14 = false
				showTool9 = false
				showTool16 = false
				break

			case 16:
				showTool16 = showTool16 === true ? false : true
				showTool0 = false
				showTool1 = false
				showTool4 = false
				showTool8 = false
				break
		}
	}

	const set_icon_1 = () => {
		iconSelected = true
		selectedIcon = 'icon1'
		storeSelectedIcon.set('icon1')
		icon1 = icon1 === false ? true : false
		if (icon1) icon1Color = iconHover
		else icon1Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'BBL')
	}

	const set_icon_2 = () => {
		iconSelected = true
		selectedIcon = 'icon2'
		storeSelectedIcon.set('icon2')
		icon2 = icon2 === false ? true : false
		if (icon2) icon2Color = iconHover
		else icon2Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'BBT')
	}

	const set_icon_3 = () => {
		iconSelected = true
		selectedIcon = 'icon3'
		storeSelectedIcon.set('icon3')
		icon3 = icon3 === false ? true : false
		if (icon3) icon3Color = iconHover
		else icon3Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'BBR')
	}

	const set_icon_4 = () => {
		iconSelected = true
		selectedIcon = 'icon4'
		storeSelectedIcon.set('icon4')
		icon4 = icon4 === false ? true : false
		if (icon4) icon4Color = iconHover
		else icon4Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'BBB')
	}

	const set_icon_5 = () => {
		iconSelected = true
		selectedIcon = 'icon5'
		storeSelectedIcon.set('icon5')
		icon5 = icon5 === false ? true : false
		if (icon5) icon5Color = iconHover
		else icon5Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'BBA')
	}

	const set_icon_6 = () => {
		iconSelected = true
		selectedIcon = 'icon6'
		storeSelectedIcon.set('icon6')
		icon6 = icon6 === false ? true : false
		if (icon6) icon6Color = iconHover
		else icon6Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'MBLC')
	}

	const set_icon_7 = () => {
		iconSelected = true
		selectedIcon = 'icon7'
		storeSelectedIcon.set('icon7')
		icon7 = icon7 === false ? true : false
		if (icon7) icon7Color = iconHover
		else icon7Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'MBTC')
	}

	const set_icon_8 = () => {
		iconSelected = true
		selectedIcon = 'icon8'
		storeSelectedIcon.set('icon8')
		icon8 = icon8 === false ? true : false
		if (icon8) icon8Color = iconHover
		else icon8Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'MBRC')
	}

	const set_icon_9 = () => {
		iconSelected = true
		selectedIcon = 'icon9'
		storeSelectedIcon.set('icon9')
		icon9 = icon9 === false ? true : false
		if (icon9) icon9Color = iconHover
		else icon9Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'MBBC')
	}

	const set_icon_10 = () => {
		iconSelected = true
		selectedIcon = 'icon10'
		storeSelectedIcon.set('icon10')
		icon10 = icon10 === false ? true : false
		if (icon10) icon10Color = iconHover
		else icon10Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'MBAC')
	}

	onDestroy(() => {
		stoElementID
		stoSelectedIcon
		stoData
	})
</script>

{#if config}
	<main use:styles={{ width }}>
		<div
			class="part_title mainTool"
			on:click={() => open_tool(0)}
			on:keydown={() => open_tool(0)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			LAYOUT POSITION
		</div>
		{#if showTool0}
			<div transition:slide={{ duration: 500 }}>
				<div class="icon_container">
					<div
						class="icon arrow_down"
						use:styles={{ icon, iconColor, iconHover }}
						on:click={() => change_order(elementID, 'down')}
						on:keydown={() => change_order(elementID, 'down')}
					/>
					<div
						class="icon arrow_up"
						use:styles={{ icon, iconColor, iconHover }}
						on:click={() => change_order(elementID, 'up')}
						on:keydown={() => change_order(elementID, 'up')}
					/>
				</div>
			</div>
		{/if}
		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(1)}
				on:keydown={() => open_tool(1)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				BLOCK CONTAINER
			</div>
			{#if showTool1}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool1')}
						on:keydown={() => open_tool('generalTool1')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool1}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
							<ColorSelector
								on:setcolor={set_bg_color}
								on:setopacity={set_bg_color}
								on:settransparent={set_bg_color}
								transparent="1"
								ID={idColor1}
								selectedColor={blockBackgroundColor}
								initialValue={blockOpac}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector
								ID={idBlockMarginTop}
								range="20"
								initialValue={blockMarginTop}
								on:sizechange={set_block_margin_top}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idBlockMarginBottom}
								range="20"
								initialValue={blockMarginBottom}
								on:sizechange={set_block_margin_bottom}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>

							<SizeSelector
								ID={idBlockPadding}
								range="20"
								initialValue={blockPadding}
								on:sizechange={set_block_padding}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(2)}
						on:keydown={() => open_tool(2)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						border
					</div>
					{#if showTool2}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon1"
									class="icon icon1"
									use:styles={{ icon, icon1Color, iconHover }}
									on:click={set_icon_1}
									on:keydown={set_icon_1}
								/>
								<div
									id="icon2"
									class="icon icon2"
									use:styles={{ icon, icon2Color, iconHover }}
									on:click={set_icon_2}
									on:keydown={set_icon_2}
								/>
								<div
									id="icon3"
									class="icon icon3"
									use:styles={{ icon, icon3Color, iconHover }}
									on:click={set_icon_3}
									on:keydown={set_icon_3}
								/>
								<div
									id="icon4"
									class="icon icon4"
									use:styles={{ icon, icon4Color, iconHover }}
									on:click={set_icon_4}
									on:keydown={set_icon_4}
								/>
								<div
									id="icon5"
									class="icon icon5"
									use:styles={{ icon, icon5Color, iconHover }}
									on:click={set_icon_5}
									on:keydown={set_icon_5}
								/>
							</div>
							{#if iconSelected}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title" use:styles={{ fsXS }}>Color</div>
									<ColorSelector
										on:setcolor={set_block_border_color}
										on:setopacity={set_block_border_color}
										ID={idColor2}
										selectedColor={blockBorderColor}
										initialValue={bbLOpac}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Width</div>
									<SizeSelector
										ID={idBlockBorderWidth}
										range="50"
										unit="px"
										initialValue={borderWidth}
										on:sizechange={set_block_border_width}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Top Radius</div>
									<SizeSelector
										ID={idBlockBTRadius}
										initialValue={borderTopRadius}
										unit="px"
										range="20"
										on:sizechange={set_block_BRT}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Bottom Radius</div>
									<SizeSelector
										ID={idBlockBBRadius}
										initialValue={borderBottomRadius}
										range="20"
										unit="px"
										on:sizechange={set_block_BRB}
									/>
								</div>
							{/if}
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(3)}
						on:keydown={() => open_tool(3)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool3}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_block_SC}
								on:setopacity={set_block_SC}
								ID={idColor3}
								selectedColor={blockBoxShadowColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idBlockShadowY}
								range="20"
								unit="px"
								initialValue={blockBoxShadowY}
								on:sizechange={set_block_SY}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idBlockShadowBlur}
								range="20"
								unit="px"
								initialValue={blockBoxShadowBlur}
								on:sizechange={set_block_SB}
							/>
						</div>
					{/if}
				</div>
			{/if}

			<div
				class="part_title mainTool"
				on:click={() => open_tool(4)}
				on:keydown={() => open_tool(4)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				TITLE CONTAINER
			</div>
			{#if showTool4}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool2')}
						on:keydown={() => open_tool('generalTool2')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool2}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
							<ColorSelector
								on:setcolor={set_title_bg_color}
								on:setopacity={set_title_bg_color}
								on:settransparent={set_title_bg_color}
								transparent="1"
								ID={idColor4}
								selectedColor={blockTitleBackgroundColor}
								initialValue={titleOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Height</div>

							<SizeSelector
								ID={idTitleHeight}
								range="500"
								unit="px"
								initialValue={blockTitleHeight}
								on:sizechange={set_block_title_height}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector
								ID={idTitleMarginTop}
								range="5"
								initialValue={blockTitleMarginTop}
								on:sizechange={set_block_title_MT}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idTitleMarginBottom}
								range="5"
								initialValue={blockTitleMarginBottom}
								on:sizechange={set_block_title_MB}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
							<SizeSelector
								ID={idTitlePadding}
								range="20"
								initialValue={blockTitlePadding}
								on:sizechange={set_block_title_P}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(5)}
						on:keydown={() => open_tool(5)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						font
					</div>
					{#if showTool5}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_block_title_FC}
								on:setopacity={set_block_title_FC}
								ID={idColor5}
								selectedColor={blockTitleFontColor}
								initialValue={titleOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_block_Title_FF}
								value={blockTitleFontFamily}
								ID={idSelect1}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSize}
								on:select={set_block_Title_FS}
								value={blockTitleFontSize}
								ID={idSelect2}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="fweight"
									class="icon iconTitleWeight"
									use:styles={{ icon, iconTitleWeight, iconHover }}
									on:click={set_block_Title_FW}
									on:keydown={set_block_Title_FW}
								/>
								<div
									id="fstyle"
									class="icon iconTitleStyle"
									use:styles={{ icon, iconTitleStyle, iconHover }}
									on:click={set_block_Title_FSTYLE}
									on:keydown={set_block_Title_FSTYLE}
								/>
								<div
									id="fdeco"
									class="icon iconTitleDeco"
									use:styles={{ icon, iconTitleDeco, iconHover }}
									on:click={set_block_Title_underline}
									on:keydown={set_block_Title_underline}
								/>
								<div
									id="fstroke"
									class="icon iconTitleStroke"
									use:styles={{ icon, iconTitleStroke, iconHover }}
									on:click={block_Title_strikethrough}
									on:keydown={block_Title_strikethrough}
								/>
							</div>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(6)}
						on:keydown={() => open_tool(6)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						font shadow
					</div>
					{#if showTool6}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Shadow Color</div>
							<ColorSelector
								on:setcolor={set_block_title_SC}
								on:setopacity={set_block_title_SC}
								ID={idColor6}
								selectedColor={blockTitleShadowColor}
								initialValue={btShadowOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idBlockTitleShadowX}
								initialValue={blockTitleShadowOffsetX}
								range="40"
								unit="px"
								on:sizechange={set_block_title_SX}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idBlockTitleShadowY}
								initialValue={blockTitleShadowOffsetY}
								range="40"
								unit="px"
								on:sizechange={set_block_title_SY}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idBlockTitleShadowB}
								initialValue={blockTitleShadowBlur}
								range="20"
								unit="px"
								on:sizechange={set_block_title_SB}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(7)}
						on:keydown={() => open_tool(7)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						alignment
					</div>
					{#if showTool7}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="fAlignL"
									class="icon txtAlignL"
									use:styles={{ icon, iconAlignL, iconHover }}
									on:click={set_block_title_AL}
									on:keydown={set_block_title_AL}
								/>

								<div
									id="fAlignC"
									class="icon txtAlignC"
									use:styles={{ icon, iconAlignC, iconHover }}
									on:click={set_block_title_AC}
									on:keydown={set_block_title_AC}
								/>

								<div
									id="fAlignR"
									class="icon txtAlignR"
									use:styles={{ icon, iconAlignR, iconHover }}
									on:click={set_block_title_AR}
									on:keydown={set_block_title_AR}
								/>
							</div>

							<div class="icon_container">
								<div
									id="vAlignT"
									class="icon txtValignT"
									use:styles={{ icon, iconValignT, iconHover }}
									on:click={set_block_title_VAT}
									on:keydown={set_block_title_VAT}
								/>

								<div
									id="vAlignC"
									class="icon txtValignC"
									use:styles={{ icon, iconValignC, iconHover }}
									on:click={set_block_title_VAC}
									on:keydown={set_block_title_VAC}
								/>

								<div
									id="vAlignB"
									class="icon txtValignB"
									use:styles={{ icon, iconValignB, iconHover }}
									on:click={set_block_title_VAB}
									on:keydown={set_block_title_VAB}
								/>
							</div>
						</div>
					{/if}
				</div>
			{/if}

			<div
				class="part_title mainTool"
				on:click={() => open_tool(8)}
				on:keydown={() => open_tool(8)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				MENU CONTAINER
			</div>
			{#if showTool8}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool3')}
						on:keydown={() => open_tool('generalTool3')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool3}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_menu_MCBGC}
								on:setopacity={set_menu_MCBGC}
								on:settransparent={set_menu_MCBGC}
								transparent="1"
								ID={idColor7}
								selectedColor={menuContainerBG}
								initialValue={menuBGOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector
								ID={idMenuContainerMT}
								initialValue={menuContainerMT}
								range="20"
								on:sizechange={set_menu_MCMT}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idMenuContainerMB}
								initialValue={menuContainerMB}
								range="20"
								on:sizechange={set_menu_MCMB}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
						</div>
						<SizeSelector
							ID={idmenuConatainerP}
							initialValue={menuConatainerP}
							range="20"
							on:sizechange={set_menu_MCP}
						/>
					{/if}
					<div
						class="part_title subTool"
						use:styles={{ subTool, subToolHover, fsXS }}
						on:click={() => open_tool(9)}
						on:keydown={() => open_tool(9)}
					>
						menu
					</div>
					{#if showTool9}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
							<ColorSelector
								on:setcolor={set_menu_MBG}
								on:setopacity={set_menu_MBG}
								on:settransparent={set_menu_MBG}
								transparent="1"
								ID={idColor8}
								selectedColor={menuBG}
								initialValue={menuOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Width</div>
							<SizeSelector ID={idMenuWidth} range="100" initialValue={menuWidth} on:sizechange={set_menu_MW} />

							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector ID={idMenuMT} range="20" initialValue={menuMT} on:sizechange={set_menu_MMT} />

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector ID={idMenuMB} range="20" initialValue={menuMB} on:sizechange={set_menu_MMB} />

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
							<SizeSelector ID={idMenuP} range="20" initialValue={menuP} on:sizechange={set_menu_MP} />
						</div>
					{/if}

					<div
						class="part_title subTool"
						use:styles={{ subTool, subToolHover, fsXS }}
						on:click={() => open_tool(10)}
						on:keydown={() => open_tool(10)}
					>
						menu shadow
					</div>

					{#if showTool10}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_menu_MSC}
								on:setopacity={set_menu_MSC}
								on:settransparent={set_menu_MSC}
								transparent="1"
								ID={idColor9}
								selectedColor={menuSC}
								initialValue={menuSopac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector ID={idMenuSX} range="20" unit="px" initialValue={menuSX} on:sizechange={set_menu_MSX} />

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector ID={idMenuSY} range="20" unit="px" initialValue={menuSY} on:sizechange={set_menu_MSY} />

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector ID={idMenuSB} range="20" unit="px" initialValue={menuSB} on:sizechange={set_menu_MSB} />
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(11)}
						on:keydown={() => open_tool(11)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						menu border
					</div>
					{#if showTool11}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon6"
									class="icon icon6"
									use:styles={{ icon, icon6Color, iconHover }}
									on:click={set_icon_6}
									on:keydown={set_icon_6}
								/>
								<div
									id="icon7"
									class="icon icon7"
									use:styles={{ icon, icon7Color, iconHover }}
									on:click={set_icon_7}
									on:keydown={set_icon_7}
								/>
								<div
									id="icon8"
									class="icon icon8"
									use:styles={{ icon, icon8Color, iconHover }}
									on:click={set_icon_8}
									on:keydown={set_icon_8}
								/>
								<div
									id="icon9"
									class="icon icon9"
									use:styles={{ icon, icon9Color, iconHover }}
									on:click={set_icon_9}
									on:keydown={set_icon_9}
								/>
								<div
									id="icon10"
									class="icon icon10"
									use:styles={{ icon, icon10Color, iconHover }}
									on:click={set_icon_10}
									on:keydown={set_icon_10}
								/>
							</div>
							{#if iconSelected}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title" use:styles={{ fsXS }}>Color</div>
									<ColorSelector
										on:setcolor={set_menu_BC}
										on:setopacity={set_menu_BC}
										ID={idColor10}
										selectedColor={menuBorderColor}
										initialValue={menuBLopac}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Width</div>
									<SizeSelector ID={idMenuBW} range="50" unit="px" initialValue={menuBW} on:sizechange={set_menu_BW} />

									<div class="sub_title" use:styles={{ fsXS }}>Top Radius</div>
									<SizeSelector
										ID={idMenuBRT}
										initialValue={menuBRT}
										unit="px"
										range="20"
										on:sizechange={set_menu_BRT}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Bottom Radius</div>
									<SizeSelector
										ID={idMenuBB}
										initialValue={menuBRB}
										range="20"
										unit="px"
										on:sizechange={set_menu_BRB}
									/>
								</div>
							{/if}
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(12)}
						on:keydown={() => open_tool(12)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						menu inset
					</div>
					{#if showTool12}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
							<ColorSelector
								on:setcolor={set_category_BG}
								on:setopacity={set_category_BG}
								on:settransparent={set_category_BG}
								transparent="1"
								ID={idColor11}
								selectedColor={categoryBgColor}
								initialValue={categoryOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idCatMarg}
								range="20"
								unit="px"
								initialValue={categoryMargin}
								on:sizechange={set_inset_margin}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector ID={idCat} range="20" unit="px" initialValue={menuBGB} on:sizechange={set_category_B} />

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
							<SizeSelector ID={idCatPad} range="20" initialValue={categoryPadding} on:sizechange={set_category_P} />
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(13)}
						on:keydown={() => open_tool(13)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						category title
					</div>
					{#if showTool13}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
							<ColorSelector
								on:setcolor={set_category_FC}
								on:setopacity={set_category_FC}
								on:settransparent={set_category_FC}
								transparent="1"
								ID={idColor15}
								selectedColor={categoryFontColor}
								initialValue={categoryFontOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_category_FF}
								value={categoryFontFamily}
								ID={idSelect1}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues options={smallFonts} on:select={set_category_FS} value={categoryFontSize} ID={idSelect2} />

							<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="fweight"
									class="icon iconTextWeight"
									use:styles={{ icon, iconTextWeight, iconHover }}
									on:click={set_category_title_FW}
									on:keydown={set_category_title_FW}
								/>
								<div
									id="fstyle"
									class="icon iconTextStyle"
									use:styles={{ icon, iconTextStyle, iconHover }}
									on:click={set_category_title_FSTYLE}
									on:keydown={set_category_title_FSTYLE}
								/>
								<div
									id="fdeco"
									class="icon iconTextDeco"
									use:styles={{ icon, iconTextDeco, iconHover }}
									on:click={set_category_title_underline}
									on:keydown={set_category_title_underline}
								/>
								<div
									id="fstroke"
									class="icon iconTextStroke"
									use:styles={{ icon, iconTextStroke, iconHover }}
									on:click={set_text_strikethrough}
									on:keydown={set_text_strikethrough}
								/>
							</div>
						</div>
					{/if}
					{#if elementID === 'foods'}
						<div
							id="item_title"
							class="part_title subTool"
							on:click={() => open_tool(15)}
							on:keydown={() => open_tool(15)}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							item title
						</div>
						{#if showTool15}
							<div transtion:slide={{ duration: 500 }}>
								<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
								<ColorSelector
									on:setcolor={set_item_title_FC}
									on:setopacity={set_item_title_FC}
									on:settransparent={set_item_title_FC}
									transparent="1"
									ID={idColor13}
									selectedColor={itemTFC}
									initialValue={itemTFOpac}
								/>

								<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
								<SelectValues options={fontFamily} on:select={set_item_FF} value={itemFontFamily} ID={idSelect1} />

								<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
								<SelectValues options={smallXFonts} on:select={set_item_FS} value={itemFontSize} ID={idSelect2} />
							</div>
						{/if}
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(14)}
						on:keydown={() => open_tool(14)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						item text
					</div>
					{#if showTool14}
						<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
						<ColorSelector
							on:setcolor={set_item_FC}
							on:setopacity={set_item_FC}
							on:settransparent={set_item_FC}
							transparent="1"
							ID={idColor13}
							selectedColor={itemFontColor}
							initialValue={itemFontOpac}
						/>

						<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
						<SelectValues options={fontFamily} on:select={set_item_FF} value={itemFontFamily} ID={idSelect1} />

						<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
						<SelectValues options={smallXFonts} on:select={set_item_FS} value={itemFontSize} ID={idSelect2} />
					{/if}
				</div>
			{/if}
		</section>
	</main>
{/if}

{#if shaderChangeOrder}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" info="change block order" />
		</div>
	</Shader>
{/if}

{#if showAlert}
	<Shader>
		<div slot="content">
			<Alert message="Please close Drinks-Container" showOkButton={false} on:alertclose={close_alert} />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
	}

	.sub_title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.sub_title {
		font-size: var(--fsXS);
		border-bottom: none;
		padding: 10px 0px 3px 10px;
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		background-color: var(--iconColor);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.arrow_down {
		mask: url('/images/tools/arrow_down.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_down.svg') no-repeat;
	}

	.arrow_up {
		mask: url('/images/tools/arrow_up.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_up.svg') no-repeat;
	}

	.icon1 {
		background-color: var(--icon1Color);
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon2 {
		background-color: var(--icon2Color);
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon3 {
		background-color: var(--icon3Color);
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon4 {
		background-color: var(--icon4Color);
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon5 {
		background-color: var(--icon5Color);
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.icon6 {
		background-color: var(--icon6Color);
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon7 {
		background-color: var(--icon7Color);
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon8 {
		background-color: var(--icon8Color);
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon9 {
		background-color: var(--icon9Color);
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon10 {
		background-color: var(--icon10Color);
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.iconTitleWeight {
		background-color: var(--iconTitleWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconTextWeight {
		background-color: var(--iconTextWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconTitleStyle {
		background-color: var(--iconTitleStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.iconTextStyle {
		background-color: var(--iconTextStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.iconTitleDeco {
		background-color: var(--iconTitleDeco);
		mask: url('/images/tools/fontU.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontU.svg') no-repeat;
	}

	.iconTextDeco {
		background-color: var(--iconTextDeco);
		mask: url('/images/tools/fontU.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontU.svg') no-repeat;
	}

	.iconTitleStroke {
		background-color: var(--iconTitleStroke);
		mask: url('/images/tools/fontST.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontST.svg') no-repeat;
	}

	.iconTextStroke {
		background-color: var(--iconTextStroke);
		mask: url('/images/tools/fontST.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontST.svg') no-repeat;
	}

	.txtAlignL {
		background-color: var(--iconAlignL);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.txtAlignC {
		background-color: var(--iconAlignC);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.txtAlignR {
		background-color: var(--iconAlignR);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.txtValignT {
		background-color: var(--iconValignT);
		mask: url('/images/tools/valignT.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignT.svg') no-repeat;
	}

	.txtValignC {
		background-color: var(--iconValignC);
		mask: url('/images/tools/valignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignC.svg') no-repeat;
	}

	.txtValignB {
		background-color: var(--iconValignB);
		mask: url('/images/tools/valignB.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignB.svg') no-repeat;
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}
</style>
